import type { CampaignStatus, RecipientStatus } from '@connexio/shared';

export type { CampaignStatus, RecipientStatus };

export interface Campaign {
  id: string;
  userId: string;
  name: string;
  status: CampaignStatus;
  subject: string;
  bodyHtml: string;
  bodyText: string;
  scheduledAt: string | null;
  sentAt: string | null;
  recipientContactIds?: string[];
  recipientGroupIds?: string[];
  recipientSegmentIds?: string[];
  exclusionSegmentIds?: string[];
  recipientCount: number;
  deliveredCount: number;
  openCount: number;
  clickCount: number;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

/** Only drafts can be edited (the server rejects anything else with 409). Shared by the detail page and the edit route. */
export function isCampaignEditable(status: CampaignStatus): boolean {
  return status === 'draft';
}

export interface CampaignSummary extends Campaign {
  openRate: number;
  clickRate: number;
}

export interface CampaignDetail extends Campaign {
  /** Recipients with status bounced / unsubscribed, from GET /campaigns/:id (CX-458). */
  bouncedCount?: number;
  unsubscribedCount?: number;
  recipients?: CampaignRecipientItem[];
}

export interface CampaignRecipientItem {
  id: string;
  campaignId: string;
  contactId: string | null;
  /** Set instead of contactId when the campaign was sent to a company segment. */
  companyId?: string | null;
  contact?: { firstName: string; lastName: string } | null;
  company?: { name: string } | null;
  email: string;
  status: RecipientStatus;
  trackingToken: string;
  deliveredAt: string | null;
  openedAt: string | null;
  clickedAt: string | null;
  bouncedAt: string | null;
  unsubscribedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface EmailTemplate {
  id: string;
  userId: string;
  name: string;
  subject: string;
  bodyHtml: string;
  bodyText: string;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface ContactGroup {
  id: string;
  userId: string;
  name: string;
  memberCount?: number;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface PaginatedMeta {
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
}
